import { FC, memo, ReactNode } from 'react'
import emptyImg from '@/assets/icons/empty.svg'
import { useTranslation } from '@/services/i18n'
import styles from './index.module.scss'

interface EmptyProps {
  text?: string
  children?: ReactNode
}

const Empty: FC<EmptyProps> = props => {
  const { t } = useTranslation()
  const { text = t('policy.empty'), children } = props
  return (
    <div className={styles.container}>
      <img src={emptyImg} alt="" />
      <span className={styles.text}>{text}</span>
      {children}
    </div>
  )
}

export default memo(Empty)
